'use client';
import '../tools/ToolsPage.css'
import './PrivacyPolicy.css';
import privacyPolicyStrings from '../../config/privacyPolicyStrings.json';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
const PrivacyPolicy = () => {
  const { title, effectiveDate, sections } = privacyPolicyStrings;
  const processTextWithLinks = (text) => {
    const emailRegex = /contact@munichindians\.com/gi;
    const urlRegex = /https:\/\/www\.munichindians\.com/gi;

    return text
      .replace(emailRegex, '<a style="all: unset; cursor: pointer; " href="mailto:contact@munichindians.com">contact@munichindians.com</a>')
      .replace(urlRegex, '<a style="all: unset; cursor: pointer; " href="https://www.munichindians.com" target="_blank" rel="noopener noreferrer">https://www.munichindians.com</a>');
  };

  const renderListItems = (items) => {
    return (
      <div>
        <ul className="item-list">
          {items.map((item, index) => {
            if (typeof item === 'object') {
              return (
                <li key={index}>
                  <span className="bold">{item.label}</span>{' '}
                  <span dangerouslySetInnerHTML={{ __html: processTextWithLinks(item.content) }} />
                </li>
              );
            }
            return <li key={index} dangerouslySetInnerHTML={{ __html: processTextWithLinks(item) }} />;
          })}
        </ul>
      </div>
    );
  };


  const renderSubsections = (subsections) => {
    return Object.entries(subsections).map(([key, subsection]) => (
      <div key={key}>
        <li className="subsection-title">{subsection.title}</li>
        {subsection.items && renderListItems(subsection.items)}
      </div>
    ));
  };

  const renderSectionContent = (content) => {
    return content.split('\n').map((paragraph, index) => (
      <p key={index} dangerouslySetInnerHTML={{ __html: processTextWithLinks(paragraph) }} />
    ));
  };


  return (
    <>
      <Header />
      <div className="tools-container">
        <h2 className="privacy-policy-title mb-2">{title}</h2>
        <div className="effective-date">{effectiveDate}</div>
        <div className="privacy-policy-content">
          {/* Introduction Section */}
          <div>
            <h4 className="section-title">{sections.introduction.title}</h4>
            <div className="section-content">
              {renderSectionContent(sections.introduction.content)}
            </div>
          </div>

          {/* Controller Section */}
          <div>
            <h4 className="section-title">{sections.controller.title}</h4>
            <div className="section-content">
              {renderSectionContent(sections.controller.content)}
            </div>
          </div>

          {/* Contact Person Section */}
          <div>
            <h4 className="section-title">{sections.contactPerson.title}</h4>
            <div className="section-content">
              <p>{sections.contactPerson.content}</p>
            </div>
          </div>

          {/* Data Types Section */}
          <div>
            <h4 className="section-title" id='section-title-list'>{sections.dataTypes.title}</h4>
            <div>
              <p>{sections.dataTypes.content}</p>
              <ul className="section-content">
                {renderSubsections(sections.dataTypes.subsections)}
              </ul>
            </div>
          </div>

          {/* Purposes Section */}
          <div>
            <h4 className="section-title">{sections.purposes.title}</h4>
            <div className="section-content">
              <p className="section-content">{sections.purposes.content}</p>
              <ul className="section-content">
                {renderSubsections(sections.purposes.subsections)}
              </ul>
            </div>
          </div>

          {/* Recipients Section */}
          <div>
            <h4 className="section-title">{sections.recipients.title}</h4>
            <div className="section-content">
              <p className="section-content">{sections.recipients.content}</p>
              {renderListItems(sections.recipients.items)}
            </div>
          </div>

          {/* Transfers Section */}
          <div>
            <h4 className="section-title">{sections.transfers.title}</h4>
            <div className="section-content">
              {renderSectionContent(sections.transfers.content)}
              {renderListItems(sections.transfers.items)}
              <p className="section-content">{sections.transfers.footer}</p>
            </div>
          </div>

          {/* Retention Section */}
          <div>
            <h4 className="section-title">{sections.retention.title}</h4>
            <div className="section-content">
              {renderSectionContent(sections.retention.content)}
              {renderListItems(sections.retention.items)}
            </div>
          </div>

          {/* Rights Section */}
          <div>
            <h4 className="section-title">{sections.rights.title}</h4>
            <div className="section-content">
              <p className="section-content">{sections.rights.content}</p>
              {renderListItems(sections.rights.items)}
              <p className="section-content">{sections.rights.footer}</p>
            </div>
          </div>

          {/* Complaint Section */}
          <div>
            <h4 className="section-title">{sections.complaint.title}</h4>
            <div className="section-content">
              {renderSectionContent(sections.complaint.content)}
            </div>
          </div>

          {/* Cookies Section */}
          <div>
            <h4 className="section-title">{sections.cookies.title}</h4>
            <div className="section-content">
              {renderListItems(sections.cookies.items)}
            </div>
          </div>

          {/* Changes Section */}
          <div>
            <h4 className="section-title">{sections.changes.title}</h4>
            <div className="section-content">
              <p className="section-content">{sections.changes.content}</p>
            </div>
          </div>

          {/* Effective Date Section */}
          <div>
            <h4 className="section-title">{sections.effectiveDate.title}</h4>
            <div className="section-content">
              <p className="section-content">{sections.effectiveDate.content}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;